import React from "react";
import MaButton from "../../../../Components/UI/ma-button";
import { MdLightbulb } from "react-icons/md";

export function PayoutSettlementBanner({ hasAccount, onAddAccount }) {
  if (hasAccount) return null;

  return (
    <div className="mb-5 flex flex-col gap-4 rounded-2xl border border-solid border-[#E5E7EB80] bg-[#FAF5FD] px-4 py-4 sm:px-5 md:mb-8 md:flex-row md:items-center md:justify-between md:px-8 md:py-3">
      <div className="flex min-w-0 flex-col gap-2 sm:flex-row sm:items-start sm:gap-3">
        <MdLightbulb className="shrink-0 text-[24px] text-[#FFCC00] sm:text-[26px]" />
        <div className="min-w-0">
          <p className="my-0 text-[13px] font-bold text-[#2E1834] sm:text-[12px] sm:font-black">
            Add Settlement Account
          </p>
          <p className="my-0 mt-1 text-[12px] leading-relaxed text-[#626262]">
            Link a settlement account where funds from your transactions will be
            deposited. This account will be used to receive payouts and process
            settlements automatically. Please ensure the account details provided
            are correct.
          </p>
        </div>
      </div>
      <div className="w-full sm:w-auto [&>div]:w-full sm:[&>div]:w-auto">
        <MaButton
          variant="primary"
          title="Add Account"
          onClick={onAddAccount}
          sx={{
            bgcolor: "#2E1834",
            minHeight: "44px",
            width: { xs: "100%", sm: "auto" },
            px: 3,
            borderRadius: "12px",
            fontWeight: 600,
          }}
        />
      </div>
    </div>
  );
}
